import React from 'react';
import { countries } from 'components/Selects/CountriesSelect/countries';
import UrlHelper from 'common/utils/url-helper';
import { mdiPencil, mdiFlagVariant } from '@mdi/js';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';

const CountryFormatter = ({ value, editable = true }) => {
  if (!value && editable) {
    return (
      <Icon
        path={mdiPencil}
        size={1}
        className='editIcon pointer bg-info-background text-info rounded-2xl p-1'
      />
    );
  }

  if (!value) {
    return <div>-</div>;
  }

  const country = countries.find(
    (country) => country.code === value.toLowerCase() || country.name == value
  );

  if (!country) {
    return (
      <div className='text-color-light flex items-center gap-2 w-full font-normal'>
        <img src='/icons/flag.svg' width={15} height={15} key={value} />
        N/A
      </div>
    );
  }

  return (
    <div className='flex items-center gap-2 w-full'>
      <img src={UrlHelper.getFlagIconUrl(country.code)} className='object-cover w-4' key={value} />
      <span>{country.name}</span>
      {editable && (
        <Icon
          path={mdiPencil}
          size={1}
          className='editIcon pointer bg-info-background text-info rounded-2xl p-1'
        />
      )}
    </div>
  );
};

export default CountryFormatter;

CountryFormatter.propTypes = {
  value: PropTypes.string,
};
